import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  private apiUrl1 = environment.apiUrl1;

  constructor(private http: HttpClient) { }

  // private handleError(error: HttpErrorResponse) {
  //   console.error('API Error:', error);

  //   if (error.error instanceof ProgressEvent) {
  //     return throwError(() => new Error('Network error. Please check your connection.'));
  //   }

  //   if (typeof error.error === 'string' && error.error.includes('<!doctype')) {
  //     return throwError(() => new Error('Server configuration error. Please contact support.'));
  //   }

  //   return throwError(() =>
  //     new Error(error.error?.Message || 'Something went wrong; please try again later.')
  //   );
  // }

  // sendContactUsEmail(data: {
  //   FullName: string;
  //   MobileNumber: string;
  //   Email: string;
  //   CompanyName: string;
  //   Reason: string;
  // }): Observable<any> {

  //   const url = `${this.apiUrl1}Email/SendEmailForContactUsForm`;

  //   console.log('Calling API:', url);
  //   console.log('Payload:', data);

  //   return this.http.post(url, data)
  //     .pipe(catchError(this.handleError));
  // }
  private handleError(error: HttpErrorResponse) {
    console.error('API Error:', error);
    if (error.error instanceof ProgressEvent) {
      return throwError(() => new Error('Network error. Please check your connection.'));
    }
    if (error.status === 404) {
      return throwError(() => new Error(`Endpoint not found: ${error.url}`));
    }
    if (typeof error.error === 'string' && error.error.includes('<!doctype')) {
      return throwError(() => new Error('Received HTML - check API URL or server routing'));
    }
    return throwError(() => new Error(error.error?.message || 'Something went wrong'));
  }

  sendContactUsEmail(data: { FullName: string; MobileNumber: string; Email: string; CompanyName: string; Reason: string }): Observable<any> {
    const url = `${this.apiUrl1}Email/SendEmailForContactUsForm`;
    console.log('Calling API:', url);
    console.log('Payload:', data);
    return this.http.post(url, data, {
      headers: { 'Content-Type': 'application/json' }
    }).pipe(
      catchError(this.handleError)
    );
  }
}
